import React from "react";
import {
  Network,
  ShieldCheck,
  UserRound,
  Timer,
  BadgeIndianRupee,
  Radar,
  Factory,
  ClipboardList,
  FileCheck2,
  Gavel,
  FileText,
  Truck,
  Pill,
  Boxes,
  Globe2,
  HelpCircle,
} from "lucide-react";

const MAP = {
  Network,
  ShieldCheck,
  UserRound,
  Timer,
  BadgeIndianRupee,
  Radar,
  Factory,
  ClipboardList,
  FileCheck2,
  Gavel,
  FileText,
  Truck,
  Pill,
  Boxes,
  Globe2,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || HelpCircle;
  return <Cmp {...props} />;
}
